import '../assets/NcEmptyContent-q-geAf0w.css';
import { defineComponent, createElementBlock, openBlock, createCommentVNode, renderSlot, toDisplayString, createTextVNode } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _hoisted_1 = {
  class: "empty-content",
  role: "note"
};
const _hoisted_2 = {
  key: 0,
  class: "empty-content__icon",
  "aria-hidden": "true"
};
const _hoisted_3 = {
  key: 0,
  class: "empty-content__name"
};
const _hoisted_4 = {
  key: 1,
  class: "empty-content__description"
};
const _hoisted_5 = {
  key: 2,
  class: "empty-content__action"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcEmptyContent",
  props: {
    description: { default: "" },
    name: { default: "" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        _ctx.$slots.icon ? (openBlock(), createElementBlock("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "icon", {}, void 0, true)
        ])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "name", {}, () => [
          _ctx.name !== "" ? (openBlock(), createElementBlock("span", _hoisted_3, toDisplayString(_ctx.name), 1)) : createCommentVNode("", true)
        ], true),
        _ctx.description !== "" || _ctx.$slots.description ? (openBlock(), createElementBlock("p", _hoisted_4, [
          renderSlot(_ctx.$slots, "description", {}, () => [
            createTextVNode(toDisplayString(_ctx.description), 1)
          ], true)
        ])) : createCommentVNode("", true),
        _ctx.$slots.action ? (openBlock(), createElementBlock("div", _hoisted_5, [
          renderSlot(_ctx.$slots, "action", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});
const NcEmptyContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-697cfd8f"]]);
export {
  NcEmptyContent as N
};
//# sourceMappingURL=NcEmptyContent-BdOezubv.mjs.map
